import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../config";
import { AuditTrailForExport } from "../util/getAuditTrailData";

const baseUrl = BASE_URL + "audit-trail";


export const getAllAuditTrail = createAsyncThunk(
  "audittrail/getAll",
  async ({ searchQuery }, { rejectWithValue }) => {
    try {
      // `${baseUrl}/get-all?${searchQuery}&search=CREATEACOPY4005`
      const response = await axios.get(
        `${baseUrl}/get-all?${searchQuery}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching audit trail data"
      );
    }
  }
);


export const getAuditTrailByid = createAsyncThunk(
  "audittrail/getByid",
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}/get-by-id/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching info");
    }
  }
);

export const getAuditTrailByPreview = createAsyncThunk(
  "audittrail/getPreview",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}node/node-data`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching info");
    }
  }
);

export const exportAuditTrailCSV = createAsyncThunk(
  "audittrail/exportCSV",
  async (_, { rejectWithValue }) => {
    try {

     await AuditTrailForExport({
        apiUrl:`${baseUrl}/export-csv`,
        file_name:"audit-trail-data-"+Date.now()+".csv",
        action:"EXPORT_AT_DATA",
        action_to_show:"Audit Trail Table data exported as CSV"
      })
      return [];
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error exporting CSV");
    }
  }
);

const auditTrailSlice = createSlice({
    name:"audittrail",
    initialState:{
        audittrailData:[],
        pagination:{limit: 15, offset: 0, total: 0, totalPages: 0},
        loading: false,
        error: null,
        newPreviewContent:[],
        originalPreviewContent:[]
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllAuditTrail.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getAllAuditTrail.fulfilled, (state, action) => {
          state.loading = false;
          state.audittrailData = action.payload.results;
          state.pagination = action.payload.pagination
        })
        .addCase(getAllAuditTrail.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "An error occurred";
        })

        .addCase(getAuditTrailByPreview.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getAuditTrailByPreview.fulfilled, (state, action) => {
          state.loading = false;
          // state.audittrailData = action.payload.results;
          // state.pagination = action.payload.pagination
        })
        .addCase(getAuditTrailByPreview.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "An error occurred";
        })
    }
})

export default auditTrailSlice.reducer;